import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { SELECT_CLS } from "@/lib/network";

// Filter daftar perangkat per SERVER: "" = semua, "none" = tanpa SERVER, atau id SERVER.
export function ServerFilter({ f, setF, prefix }) {
  const [opts, setOpts] = useState([]);
  useEffect(() => {
    Promise.all([api.get("/network/servers"), api.get("/network/servers", { params: { archived: true } })])
      .then(([a, b]) => setOpts([...a.data, ...b.data.filter((s) => s.member_count > 0)]))
      .catch(() => setOpts([]));
  }, []);
  return (
    <select className={SELECT_CLS} value={f.server_id || ""} onChange={(e) => setF((x) => ({ ...x, server_id: e.target.value }))} data-testid={`${prefix}-filter-server`}>
      <option value="">Semua SERVER</option>
      <option value="none">Tanpa SERVER</option>
      {opts.map((s) => <option key={s.id} value={s.id}>{s.kode} · {s.nama}{s.archived ? " (ARSIP)" : ""}</option>)}
    </select>
  );
}
